// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero-module--container--3dDgs","indicator":"Hero-module--indicator--3DoM8"};